<div class="card__top-center">
  @if (isPort()) {
    <h3>{{ "PortDetails" | translate }}</h3>
  } @else {
    <h3>{{ "ServiceDetails" | translate }}</h3>
  }
  @if (subscription()) {
    <div class="card__top-actions">
      @if (!isTerminated()) {
        @if (isDirty()) {
          <div style="display: flex; flex-direction: row; align-items: center; gap: 6px">
            <span>{{ "Services.Status.Locked" | translate }}</span>
            <svg-icon
              style="align-self: center"
              src="assets/images/icons/lock.svg"
              [matTooltip]="'Selfservice.Tooltip.Locked' | translate"
            ></svg-icon>
          </div>
        }
        @if (!isWireless()) {
          <notification-button [subscription]="subscription()" />
        }
        @if (isCurrentOrganisation) {
          <report-incident [subscription]="subscription()" />
        }
      }
    </div>
  }
</div>
